import React from "react";
import { Chip, Grid, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { PhotoConsumer, PhotoProvider } from "react-photo-view";
import { isArray, isEmpty } from "lodash";

import { ReportModalContext } from "../../context";
import PostServiceApi from "../../../../../../../services/post-service";

import WarningIcon from "@material-ui/icons/ReportProblemOutlined";
import PermMediaOutlinedIcon from "@material-ui/icons/PermMediaOutlined";

import "../../style.css";
import { NotificationManager } from "react-notifications";

const SkeletonView = () => {
  return (
    <Grid container className="gap-x-16">
      <Skeleton variant="rect" animation="wave" width={100} height={100} />
      <Skeleton variant="rect" animation="wave" width={100} height={100} />
      <Skeleton variant="rect" animation="wave" width={100} height={100} />
    </Grid>
  );
};

const EmptyImagesView = () => {
  return (
    <Grid container direction="column" className="gap-y-8  items-center">
      <PermMediaOutlinedIcon className="txt-secondary" />
      <Typography variant="caption" className="txt-secondary">
        No Attachments
      </Typography>
    </Grid>
  );
};

const ReportDetailedView = () => {
  const {
    report: { id, images = [], reason = {}, reasonOther = "" },
    postId,
  } = React.useContext(ReportModalContext);

  const [attachments, setAttachments] = React.useState([]);

  React.useEffect(() => {
    const getAttachments = async () => {
      if (!Array.isArray(images)) {
        return;
      }

      let tempImages = [];
      for (const image of images) {
        const response = await PostServiceApi.getReportedPostImage({
          postId,
          reportId: id,
          imageId: image,
        });
        if (!response.success) {
          NotificationManager.error("Image fetching failed");
          return;
        }
        if (response.body instanceof Blob) {
          const imageUrl = URL.createObjectURL(response.body);
          tempImages.push(imageUrl);
        }
      }
      setAttachments((prevAttachments) => [...prevAttachments, ...tempImages]);
    };
    setAttachments([]);
    getAttachments();
  }, [images, id, postId]);

  return (
    <Grid
      container
      direction="column"
      className="report-detailed-view gap-y-24"
    >
      <Typography className="section-title font-bold gap-x-4 txt-primary">
        <WarningIcon className="warning-icon" />
        Report Details
      </Typography>

      <Grid container className="gap-x-16 items-center">
        <Typography variant="body2" className="txt-secondary font-medium">
          Reason
        </Typography>
        <Chip className="reported-reason" label={reason?.reason ?? ""} />
      </Grid>

      <Grid container direction="column" className="gap-y-8">
        <Typography variant="body2" className="txt-secondary font-medium">
          Additional Details
        </Typography>
        <Grid container className="detailed-area p-16">
          <Typography variant="body2" className="txt-secondary">
            {reasonOther || "N/A"}
          </Typography>
        </Grid>
      </Grid>

      <Grid container direction="column" className="gap-y-8">
        <Typography variant="body2" className="txt-secondary font-medium">
          {`Attachments ${
            isArray(images) && !isEmpty(images) ? `(${images.length})` : ""
          }`}
        </Typography>
        <Grid container xs className="detailed-area p-16">
          {isEmpty(images) ? (
            <EmptyImagesView />
          ) : isEmpty(attachments) ? (
            <SkeletonView />
          ) : (
            <PhotoProvider>
              {attachments.map((image) => (
                <PhotoConsumer src={image}>
                  <img
                    src={image}
                    alt=""
                    className="photos"
                    width={150}
                    height={150}
                  />
                </PhotoConsumer>
              ))}
            </PhotoProvider>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReportDetailedView;
